import { Navigate, Outlet } from 'react-router-dom';
import { useClientAccess } from './useClientAccess';

/* Gate contentIQ: Expert-Studio-only users are sent to Expert Studio. UX only —
   the sensitive report APIs are enforced server-side; contentIQ endpoints stay
   open because the Expert Studio flow reuses some of them. */
export function RequireContent() {
  const { access, isLoading } = useClientAccess();
  if (isLoading || !access) return null;
  return access.canContent ? <Outlet /> : <Navigate to="/studio" replace />;
}
